import { ValueHash } from '@unreserved-frontend-v2/utils/types'
import { ParsedUrlQuery } from 'querystring'
import { ROUTE_BASED_PARAMS } from './constants'

/**
 * Method that returns an object with route sensitive params split apart into {query, routeParams}
 *
 * @param query
 * @returns { query: ParsedUrlQuery, routeParams: ValueHash<unknown> }
 */
export function getRouteSplitQueryParams(query: ValueHash<unknown>) {
  const routeParamKeys = Object.values(ROUTE_BASED_PARAMS) as string[]

  return Object.entries(query).reduce(
    (acc, [key, value]) => {
      acc[routeParamKeys.includes(key) ? 'routeParams' : 'query'][key] = value

      return acc
    },
    { query: {} as ParsedUrlQuery, routeParams: {} as ValueHash<unknown> }
  )
}
